module.exports = __webpack_public_path__ + "media/unipod/mechanical_services_3-4e693904.jpg";